import { initUserTypeRequired, initUserTypeWarnings } from "../../utils/user-type-warnings";

export const initSignupCompleteForm = () => {
  const signupComplete = document.getElementById("signup-complete") as HTMLDivElement;

  if (!signupComplete) {
    return;
  }

  const step1 = signupComplete.querySelector(".step-1") as HTMLDivElement;
  const step2 = signupComplete.querySelector(".step-2") as HTMLDivElement;
  const buttonGoToStep2 = signupComplete.querySelector(".go-to-step-2") as HTMLButtonElement;
  const buttonGoToStep1 = signupComplete.querySelector(".go-to-step-1") as HTMLButtonElement;
  const nameInputs = step1.querySelectorAll<HTMLInputElement>("input[required]");

  // "Required to add." above the empty field, as in the design; the server validates again on submit
  const validateNames = (): boolean => {
    let firstInvalid: HTMLInputElement | null = null;

    nameInputs.forEach((input) => {
      const isFilled = input.value.trim() !== "";
      const error = step1.querySelector(`[data-required-error="${input.name}"]`);

      error?.classList.toggle("d-none", isFilled);
      input.classList.toggle("is-invalid", !isFilled);

      if (!isFilled && !firstInvalid) {
        firstInvalid = input;
      }
    });

    if (firstInvalid) {
      (firstInvalid as HTMLInputElement).focus();
      return false;
    }

    return true;
  };

  nameInputs.forEach((input) => {
    input.addEventListener("input", () => {
      if (input.value.trim() === "") {
        return;
      }

      step1.querySelector(`[data-required-error="${input.name}"]`)?.classList.add("d-none");
      input.classList.remove("is-invalid");
    });
  });

  buttonGoToStep2.addEventListener("click", () => {
    if (!validateNames()) {
      return;
    }

    step1.classList.add("d-none");
    step2.classList.remove("d-none");

    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  });

  buttonGoToStep1.addEventListener("click", () => {
    step2.classList.add("d-none");
    step1.classList.remove("d-none");

    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  });

  initUserTypeWarnings(signupComplete);

  // The names are checked when going to step 2, the user type here; the server validates both again
  const form = signupComplete.querySelector<HTMLFormElement>("form");
  if (form) {
    // Enter in a name field submits the form while step 1 shows: go on to step 2 as the button
    // does. Registered before the user type check, which then does not run (its message sits in
    // step 2 and would show right away).
    form.addEventListener(
      "submit",
      (event) => {
        if (!step2.classList.contains("d-none")) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        buttonGoToStep2.click();
      },
      { capture: true },
    );

    initUserTypeRequired(form);
  }
};
